import { RARITY, REQUIREMENT_TYPE, ACTION_TYPE } from './cards';

/**
 * Starter Cards - Given to new users (3 of the 5 common cards)
 */
export const STARTER_CARDS = [
  {
    cardId: 'check-in',
    name: 'Check-In',
    rarity: RARITY.COMMON,
    description: 'Log in for 3 consecutive days',
    requirement: { type: REQUIREMENT_TYPE.STREAK, action: ACTION_TYPE.LOGIN, target: 3 },
    reward: 15
  },
  {
    cardId: 'micro-move',
    name: 'Micro Move',
    rarity: RARITY.COMMON,
    description: 'Make any deposit',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.DEPOSIT, count: 1 },
    reward: 10
  },
  {
    cardId: 'window-shopper',
    name: 'Window Shopper',
    rarity: RARITY.COMMON,
    description: 'Log 1 impulse save',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.IMPULSE_SAVE, count: 1 },
    reward: 12
  }
];

/**
 * Additional Common Cards (2 more to complete the 5 common cards)
 */
const ADDITIONAL_COMMON_CARDS = [
  {
    cardId: 'penny-pinch',
    name: 'Penny Pinch',
    rarity: RARITY.COMMON,
    description: 'Make 5 deposits of any amount',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.DEPOSIT, count: 5 },
    reward: 12
  },
  {
    cardId: 'tomorrows-dollar',
    name: "Tomorrow's Dollar",
    rarity: RARITY.COMMON,
    description: 'Deposit at least $10 in one transaction',
    requirement: { type: REQUIREMENT_TYPE.THRESHOLD, action: ACTION_TYPE.DEPOSIT, amount: 10 },
    reward: 15
  }
];

/**
 * Rare Cards (4 cards)
 */
const RARE_CARDS = [
  {
    cardId: 'stacker',
    name: 'Stacker',
    rarity: RARITY.RARE,
    description: 'Make 7 deposits before card expires',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.DEPOSIT, count: 7 },
    reward: 30
  },
  {
    cardId: 'round-up-rally',
    name: 'Round-Up Rally',
    rarity: RARITY.RARE,
    description: 'Log 5 round-up events',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.ROUND_UP, count: 5 },
    reward: 25
  },
  {
    cardId: 'ghost-mode',
    name: 'Ghost Mode',
    rarity: RARITY.RARE,
    description: 'No withdrawals for 7 consecutive days',
    requirement: { type: REQUIREMENT_TYPE.STREAK, action: ACTION_TYPE.NO_WITHDRAWAL, target: 7 },
    reward: 35
  },
  {
    cardId: 'pay-yourself-first',
    name: 'Pay Yourself First',
    rarity: RARITY.RARE,
    description: 'Make a deposit on 3 different days',
    requirement: { type: REQUIREMENT_TYPE.ACTION, action: ACTION_TYPE.DEPOSIT, count: 3, uniqueDays: true },
    reward: 28
  }
];

/**
 * Epic Cards (3 cards)
 */
const EPIC_CARDS = [
  {
    cardId: 'streak-fortress',
    name: 'Streak Fortress',
    rarity: RARITY.EPIC,
    description: '14-day login streak',
    requirement: { type: REQUIREMENT_TYPE.STREAK, action: ACTION_TYPE.LOGIN, target: 14 },
    reward: 75
  },
  {
    cardId: 'the-hundred',
    name: 'The Hundred',
    rarity: RARITY.EPIC,
    description: 'Deposit $100+ in a single transaction',
    requirement: { type: REQUIREMENT_TYPE.THRESHOLD, action: ACTION_TYPE.DEPOSIT, amount: 100 },
    reward: 80
  },
  {
    cardId: 'blackout-week',
    name: 'Blackout Week',
    rarity: RARITY.EPIC,
    description: 'No withdrawals for 14 days',
    requirement: { type: REQUIREMENT_TYPE.STREAK, action: ACTION_TYPE.NO_WITHDRAWAL, target: 14 },
    reward: 90
  }
];

/**
 * Legendary Cards (3 cards)
 */
const LEGENDARY_CARDS = [
  {
    cardId: 'the-marathon',
    name: 'The Marathon',
    rarity: RARITY.LEGENDARY,
    description: '30-day login streak',
    requirement: { type: REQUIREMENT_TYPE.STREAK, action: ACTION_TYPE.LOGIN, target: 30 },
    reward: 200
  },
  {
    cardId: 'emergency-armor',
    name: 'Emergency Armor',
    rarity: RARITY.LEGENDARY,
    description: 'Next withdrawal won\'t deduct M (one-time shield)',
    requirement: { type: REQUIREMENT_TYPE.PASSIVE, effect: 'shield-withdrawal' },
    reward: 150
  },
  {
    cardId: 'the-doubler',
    name: 'The Doubler',
    rarity: RARITY.LEGENDARY,
    description: 'Next card completion reward is doubled',
    requirement: { type: REQUIREMENT_TYPE.PASSIVE, effect: 'double-reward' },
    reward: 175
  }
];

/**
 * Card Pool - Organized by rarity for draw mechanics
 * Total: 15 cards (5 common, 4 rare, 3 epic, 3 legendary)
 */
export const CARD_POOL = {
  [RARITY.COMMON]: [...STARTER_CARDS, ...ADDITIONAL_COMMON_CARDS],
  [RARITY.RARE]: RARE_CARDS,
  [RARITY.EPIC]: EPIC_CARDS,
  [RARITY.LEGENDARY]: LEGENDARY_CARDS
};
